var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
var TituloProducto = function (_a) {
    var titulo = _a.titulo, subtitulo = _a.subtitulo, url = _a.url, onClick = _a.onClick, contextoVisual = _a.contextoVisual;
    return (React.createElement(TituloDeProducto, { onClick: function (e) { return onClick(e); }, href: url, title: "".concat(titulo, " ").concat(subtitulo && subtitulo), contextoVisual: contextoVisual },
        titulo,
        " ",
        subtitulo && subtitulo));
};
var TituloDeProducto = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  font-size: 0.8rem;\n  line-height: 1rem !important ;\n  text-decoration: none;\n  color: black;\n  margin-bottom: 5px;\n\n  ", "\n\n  &:hover {\n    color: ", ";\n  }\n"], ["\n  display: block;\n  font-size: 0.8rem;\n  line-height: 1rem !important ;\n  text-decoration: none;\n  color: black;\n  margin-bottom: 5px;\n\n  ", "\n\n  &:hover {\n    color: ", ";\n  }\n"])), function (_a) {
    var contextoVisual = _a.contextoVisual;
    return contextoVisual !== "lista-personalizada-privada" &&
        "\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n  ";
}, function (props) { return props.theme.primario; });
export default TituloProducto;
var templateObject_1;
